// src/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --background-color-sidebar: #1d1d1d;
    --background-color-main: #121212;
    --background-color-container: #1a1a1a;
    --lines-color-main: #444444;
    --correctly-typed-color: #444444;
    --incorrectly-typed-color: #ff8a80;
    --hover-border-color: #d4b3ff;
    --text-color-white: #FFF;
    --text-muted: #cfcfcf;
    --hover-background-color: rgba(255, 255, 255, .075);
    --h5-font-size-desktop: 16px;
    --h2-font-size-desktop: 32px;
    --untyped-text-color: #e0e0e0; 

  }
  * {
    margin: 0; padding: 0;
    box-sizing: border-box;
    font-family: 'Roboto Mono', monospace;
  }
  body {
    background-color: var(--background-color-main);
    color: var(--text-color-white);
    min-height: 100vh;
  }
  a { text-decoration: none; color: var(--text-color-white); }
`;
